import { render } from "./PointsTransactionDialog.vue?vue&type=template&id=6082296c"
import script from "./PointsTransactionDialog.vue?vue&type=script&lang=js"
export * from "./PointsTransactionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__